<template>
  <div class="EditContacts">
    <ld-header
      transparent
      v-show="showHeader"
    >
      <span
        v-if="id"
        slot="right"
        @click="del"
      >删除</span>
    </ld-header>

    <div class="wrap">
      <van-cell-group :title="showHeader?`${id ? '编辑' : '新增'}常用旅客`:''">
        <van-cell><h4>姓名手机号</h4></van-cell>
        <van-field
          v-model="detail.chName"
          required
          clearable
          :label="$t('D038','中文姓名')"
          placeholder="与证件保持一致"
          @blur.prevent="changeBlur"
        />


        <van-cell
          :title="$t('D016','性别')"
          title-class="van-field__label"
          required
        >
          <van-radio
            v-model="detail.sex"
            slot="right-icon"
            name="M"
          >
            {{ $t('D018', '男') }}
          </van-radio>
          <van-radio
            v-model="detail.sex"
            slot="right-icon"
            name="F"
          >
            {{ $t('D019', '女') }}
          </van-radio>
        </van-cell>


        <van-field
          v-model="detail.phoneNumber"
          required
          clearable
          :label="$t('F008','手机号')"
          placeholder="请填写手机号"
          @blur.prevent="changeBlur"
          :error-message="phoneErrMsg"
        />
      </van-cell-group>

      <van-cell-group>
        <van-cell><h4>身份信息</h4></van-cell>
        <van-field
          v-model="detail.idNumber"
          label="身份证号"
          placeholder="与证件保持一致"
          clearable
          :error-message="idNumberErrMsg"
          @blur.prevent="changeBlur"
        />
        <van-field
          v-model="detail.passport"
          :label="$t('D005','护照')"
          placeholder="与证件保持一致"
          clearable
          @blur.prevent="changeBlur"
        />
        <van-field
          label="证件有效期"
          readonly
          clickable
          placeholder="与证件保持一致"
          @click="dateShowAction('passportPeriod')"
          :value="detail.passportPeriod"
        />

        <van-field
          v-model="detail.otherNumber"
          label="其它证件"
          placeholder="与证件保持一致"
          clearable
          @focus.prevent="changefocus"
        />
        <van-field
          label="证件有效期"
          readonly
          clickable
          placeholder="与证件保持一致"
          @click="dateShowAction('otherPeriod')"
          :value="detail.otherPeriod"
        />
      </van-cell-group>

      <van-cell-group>
        <van-cell><h4>其他个人信息</h4></van-cell>
        <van-field
          :label="$t('D013','出生日期')"
          required
          readonly
          clickable
          placeholder="与证件保持一致"
          @click="dateShowAction('born')"
          :value="detail.born"
        />
      </van-cell-group>

      <div class="font12 gray wrap">
        如需完善员工详细资料，请联系管理员进行处理
      </div>
    </div>

    <div class="submit-btn__wrap">
      <ld-button
        @click="save"
        main3
        size="lg"
      >
        {{ $t('B010', '保存') }}
      </ld-button>
    </div>

    <van-popup
      v-model="dateShow"
      position="bottom"
      :close-on-popstate="true"
      :style="{ height: '40%' }"
    >
      <van-datetime-picker
        v-model="datepickModel"
        @confirm="datePickerConfirm"
        @cancel="dateShow = false"
        :min-date="minDate"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>
import {Cell, CellGroup, DatetimePicker, Field, Popup, Radio} from 'vant'
import ldButton from 'Common/ldButton'
import contactsInteractor from 'Domain/use-cases/contacts-interactor'
import {validators} from 'Utils/valid'
import {formatDate} from 'Utils/dateUtil'
import {changeBlur, changefocus} from 'Utils/tools'
import {excludeSpecial} from 'Utils/string'
import {getIDcardInfo} from 'Utils/publicFun'

export default {
  name: 'EditContacts',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    ldButton
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      detail: {
        sex: 'M'
      },
      minDate: new Date('1900-01-01'),
      datepickModel: new Date(),
      currentCheckBorn: '',
      phoneErrMsg: '',
      idNumberErrMsg: '',
      dateShow: false
    }
  },
  async created() {
    if (this.id) this.query()
  },
  methods: {
    changeBlur, changefocus,
    dateShowAction(row) {
      this.currentCheckBorn = row
      this.datepickModel = this.detail[this.currentCheckBorn]
        ? new Date(this.detail[this.currentCheckBorn])
        : new Date()
      this.dateShow = true
    },
    datePickerConfirm(date) {
      this.detail[this.currentCheckBorn] = formatDate(date).date
      this.dateShow = false
    },
    async query() {
      let {data} = await contactsInteractor.getContactsById(this.id)
      this.detail = data
    },
    async save() {
      if (this.phoneErrMsg !== '') return
      if (this.idNumberErrMsg !== '') return

      if (!this.detail.chName) {
        this.$validErrorTips('姓名不能为空')
      } else if (!this.detail.idNumber && !this.detail.passport && !this.detail.otherNumber) {
        this.$validErrorTips('证件号码不能为空')
      } else if (!this.detail.born) {
        this.$validErrorTips('出生日期不能为空')
      } else if (!this.detail.sex) {
        this.$validErrorTips('性别不能为空')
      } else {
        await contactsInteractor.saveContacts(this.detail)
        this.$dialog.alert({
          message: '保存成功'
        }).then(() => {
          if (this.id == 0) {
            this.detail = {}
          }
          this.back()
        })
      }
    },
    /**
     * 删除常旅客
     */
    del() {
      this.$dialog.confirm({
        message: '确定删除吗？'
      }).then(async () => {
        await contactsInteractor.deleteContacts(this.id)
        this.$dialog({message: '删除成功！'}).then(() => {
          this.back()
        })
      })
    },
    back() {
      if (this.showHeader) {
        this.$router.go(-1)
      } else {
        this.$emit('call-back', false)
      }
    }
  },
  watch: {
    'detail.phoneNumber': function (val) {
      this.detail.phoneNumber = excludeSpecial(val)
      if (!validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'detail.idNumber': function (val) {
      this.detail.idNumber = excludeSpecial(val)
      if (val && !validators['is-idCard'](val).valid) {
        this.idNumberErrMsg = validators['is-idCard'](val).msg
      } else {
        this.idNumberErrMsg = ''
      }
      if (!this.detail.born && this.detail.idNumber && !this.idNumberErrMsg) {
        this.detail.born = getIDcardInfo(this.detail.idNumber).born
      }
    }
  }
}
</script>

<style lang="less">
.EditContacts {
  h4 {
    margin: 0;
  }

  .wrap {
    padding: 10px 6px;
  }

  .submit-btn__wrap {
    padding: 0 37px;
    margin: 0 auto 10px;
  }

  .van-cell-group__title {
    padding-top: 0;
    font-size: @font-size-20;
    letter-spacing: 1px;
    color: @color-text-black;
  }

  .van-cell-group {
    margin-top: 5px;
  }

  .van-cell__title + .van-radio {
    padding-right: 20px;
  }
}
</style>

